import { render, staticRenderFns } from "./TableBlueLabelInsurance.vue?vue&type=template&id=a15ac00c&scoped=true&"
import script from "./TableBlueLabelInsurance.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelInsurance.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelInsurance.vue?vue&type=style&index=0&id=a15ac00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15ac00c",
  null
  
)

export default component.exports